import { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';

interface HealthBarProps {
    hp: number;
    maxHp: number;
    offset?: [number, number, number];
}

export const HealthBar = ({ hp, maxHp, offset = [0, 1.2, 0] }: HealthBarProps) => {
    const ref = useRef<THREE.Group>(null);

    useFrame(({ camera }) => {
        if (ref.current) {
            ref.current.lookAt(camera.position);
        }
    });

    const ratio = Math.max(0, Math.min(1, hp / maxHp));

    return (
        <group ref={ref} position={offset}>
            {/* Background */}
            <mesh position={[0, 0, -0.01]}>
                <planeGeometry args={[1, 0.1]} />
                <meshBasicMaterial color="red" />
            </mesh>
            {/* Foreground */}
            <mesh position={[(ratio - 1) / 2, 0, 0]} scale={[ratio, 1, 1]}>
                <planeGeometry args={[1, 0.1]} />
                <meshBasicMaterial color="#00ff00" />
            </mesh>
        </group>
    );
};
